/**
 * Maps the active i18next language to a full BCP-47 tag that `Intl` accepts.
 *
 * Single source of truth for locale-aware `Intl.NumberFormat`/`Intl.DateTimeFormat` calls across
 * the app — always call this fresh (never cache the result in a module-level constant) so
 * formatting stays reactive to language switches.
 */
import i18n from './i18n';

const LOCALE_MAP: Record<string, string> = {
  en: 'en-US',
  ru: 'ru-RU',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
  de: 'de-DE',
  tr: 'tr-TR',
  hi: 'hi-IN',
  ja: 'ja-JP',
};

/** Current UI language resolved to a BCP-47 tag. Falls back to 'en-US' for any unrecognised code. */
export function getIntlLocale(): string {
  return LOCALE_MAP[i18n.language] ?? 'en-US';
}
